import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetScienceContests } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { scienceContestsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfScienceContestContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const studentContests = useAppSelector(scienceContestsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().scienceContests });

  const hasData = studentContests.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(studentContests, academicYears);
  return (
    <PdfCommonDataEntityContainer title="Конкурсы, конференции и иные события" Icon={IconWidgetScienceContests}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfScienceContestContainer;
